import React from 'react'
import { Outlet } from 'react-router-dom';
import HomepageLayout from '../components/layouts/homepageLayout/homepageLayout';

function HomepageRoute() {
  return (
    <HomepageLayout>
      <Outlet />
    </HomepageLayout>
  )
}

export default HomepageRoute